import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";

// Deposit printed on the retainer: staff type the exact amount; the calculated amount is shown as a suggestion.
export function RetainerDepositField({ appId, label, deposit, onSaved }) {
  const saved = deposit?.saved;
  const suggested = Number(deposit?.suggested || 0);
  const [val, setVal] = useState(saved != null ? String(saved) : "");
  useEffect(() => { setVal(saved != null ? String(saved) : ""); }, [saved]);

  const save = async (v) => {
    const next = String(v ?? "").trim();
    if (next === (saved != null ? String(saved) : "")) return;
    try {
      await api.put(`/applications/${appId}/retainer-deposit`, { amount: next });
      toast.success(next ? "Deposit saved for this case" : "Deposit cleared — using the calculated amount");
      onSaved?.();
    } catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div data-testid="retainer-deposit-field">
      <label className="text-[11px] font-medium text-slate-500">{label}<span className="text-slate-300"> · saved on this case</span></label>
      <input data-testid="rf-DEPOSIT_AMOUNT" inputMode="decimal" value={val} placeholder={suggested.toFixed(2)}
        onChange={(e) => setVal(e.target.value)} onBlur={(e) => save(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }}
        className="mt-1 w-full px-2.5 py-2 rounded-lg border border-slate-200 text-sm" />
      <div className="mt-1 flex items-center gap-2 text-[11px] text-slate-400">
        <span data-testid="retainer-deposit-suggestion">Suggested: ${suggested.toFixed(2)} (payments received)</span>
        {saved == null && suggested > 0 && <button type="button" data-testid="retainer-deposit-use-suggestion" onClick={() => save(suggested.toFixed(2))} className="font-semibold text-primary hover:underline">Use</button>}
        {saved != null && <button type="button" data-testid="retainer-deposit-clear" onClick={() => save("")} className="font-semibold text-primary hover:underline">Clear</button>}
      </div>
    </div>
  );
}
